export const dropdownTriggers = {
  hover: 'hover',
  click: 'click',
};
